import MicroModal from "micromodal";
import Vue from "vue";
import cartFilters from "./cart-filters";
import { getCustomCart, removeItem, addToCart, setQuantity } from "./cart-requests";
import updateCartBadge from "./cart-count";

let openCartTriggers = Array.from(document.querySelectorAll("#open-cart-modal"));
let productForms = Array.from(document.querySelectorAll(".add-to-cart"));

function cloneDeep(object) {
    return JSON.parse(JSON.stringify(object));
}

function initCartApp() {
    console.log("Init cart modal");
    var el = document.getElementById("cart-modal");
    if (!el) return;
    var token = el.getAttribute("data-token");

    var app = new Vue({
        el: el,
        delimiters: ["${", "}"],
        filters: cartFilters,
        data: {
            cart: null,
            cartErrors: null,
            loading: false
        },
        mounted: async function() {},
        computed: {},
        methods: {
            loadCart: async function(showLoader) {
                if (showLoader) this.loading = true;
                let result = await getCustomCart();
                this.cart = result.body.cart;
                console.log('result.body.cart', result.body.cart);
                updateCartBadge(this.cart);
                if (showLoader) this.loading = false;
            },
            updateQuantity: async function(line, count) {
                line.qty = parseInt(line.qty) + count;

                if (line.qty > 0) {
                    this.cart.itemTotal = null;
                    this.cart.itemSubtotal = null;
                    this.cart = cloneDeep(this.cart);
                    let result = await setQuantity(token, line.id, line.qty);

                    if (result.body.error) {
                        this.cartErrors = result.body.errors;
                    } else {
                        this.cartErrors = null;
                    }

                    this.loadCart(false);
                } else {
                    this.remove(line);
                }
            },
            addToCart: async function(variant, count, extras) {
                this.loading = true;

                var guarantees = [];
                extras.forEach(g => {
                    guarantees.push(g.id);
                });
                await addToCart(token, variant, count, guarantees);
                await this.loadCart(false);
                this.loading = false;
            },
            remove: async function(item) {
                var i = this.cart.lineItems.indexOf(item);
                this.cart.lineItems.splice(i, 1);
                this.cart.itemTotal = null;
                this.cart.itemSubtotal = null;
                this.cart = cloneDeep(this.cart);
                let result = await removeItem(token, item.id);
                this.loadCart(false);
            }
        },
        watch: {}
    });

    window.cart = app;
}

window.openCart = function() {
    MicroModal.show("cart-modal", {
        awaitCloseAnimation: true,
        onShow: modal => {
            window.cart.loadCart(true);
        },
        onClose: modal => {
            window.cart.cartErrors = null;
        }
    });
}

function initCartListeners() {
    // Triggers to open cart
    openCartTriggers.forEach(trigger =>
        trigger.addEventListener("click", e => {
            e.preventDefault();
            window.openCart();
        })
    );

    // Triggers to add product to cart
    productForms.forEach(form => {
        let amt = form.querySelector(".cart-amount");
        let amtUp = form.querySelector(".cart-amount-up");
        let amtDown = form.querySelector(".cart-amount-down");

        form.addEventListener("submit", e => {
            e.preventDefault();
            let variant = form.dataset.variant;
            let guarantees = JSON.parse(form.dataset.guarantees);
            let count = amt ? parseInt(amt.value) : 1;
            window.cart.addToCart(variant, count, guarantees);
            window.openCart();
        });

        if (amtUp) {
            amtUp.addEventListener("click", e => {
                e.preventDefault();
                amt.stepUp();
            });
        }

        if (amtDown) {
            amtDown.addEventListener("click", e => {
                e.preventDefault();
                amt.stepDown();
            });
        }

    });
}

export default function init() {
    initCartApp();
    initCartListeners();
}
